export type LocationContent = {
  slug: string;
  name: string;
  shortName: string;
  address: string[];
  fullAddress: string;
  phone: string;
  phoneHref: string;
  fax: string;
  hours: { label: string; value: string }[];
  directionsHref: string;
  mapEmbedSrc: string;
  description: string;
  neighborhood: string;
  parking: string;
};

export const LOCATIONS: LocationContent[] = [
  {
    slug: "fairfield",
    name: "Fairfield Office",
    shortName: "Fairfield",
    address: ["52 Beach Rd., #206", "Fairfield, CT 06824"],
    fullAddress: "52 Beach Rd., #206, Fairfield, CT 06824",
    phone: "203-255-2677",
    phoneHref: "tel:2032552677",
    fax: "203-255-1659",
    hours: [
      { label: "Monday – Thursday", value: "8am – 5pm" },
      { label: "Friday – Sunday", value: "Closed" },
    ],
    directionsHref:
      "https://www.google.com/maps/dir/?api=1&destination=52+Beach+Rd+%23206%2C+Fairfield%2C+CT+06824",
    mapEmbedSrc:
      "https://www.google.com/maps?q=52+Beach+Rd+%23206%2C+Fairfield%2C+CT+06824&output=embed",
    description:
      "Our Fairfield office sits just off the Post Road, a short walk from the Fairfield Metro and downtown shops. Inside, you'll find a calm, light-filled space designed to make orthodontic visits feel a little more like a deep breath.",
    neighborhood:
      "Convenient to downtown Fairfield, Southport, Westport, and the Black Rock area of Bridgeport.",
    parking: "Free patient parking is available on-site, with elevator access to suite 206.",
  },
  {
    slug: "orange",
    name: "Orange Office",
    shortName: "Orange",
    address: ["185 Boston Post Rd.", "Orange, CT 06477"],
    fullAddress: "185 Boston Post Rd., Orange, CT 06477",
    phone: "203-799-0600",
    phoneHref: "tel:2037990600",
    fax: "203-799-0550",
    hours: [
      { label: "Monday – Thursday", value: "8am – 5pm" },
      { label: "Friday – Sunday", value: "Closed" },
    ],
    directionsHref:
      "https://www.google.com/maps/dir/?api=1&destination=185+Boston+Post+Rd%2C+Orange%2C+CT+06477",
    mapEmbedSrc:
      "https://www.google.com/maps?q=185+Boston+Post+Rd%2C+Orange%2C+CT+06477&output=embed",
    description:
      "Our Orange office is right on Boston Post Road, easy to reach from I-95 and the Wilbur Cross Parkway. The bright, modern suite is designed for comfortable visits — for kids, teens, and adults alike.",
    neighborhood:
      "Convenient to Orange, Milford, Woodbridge, West Haven, and the greater New Haven area.",
    parking: "Generous on-site parking with step-free access from the front lot.",
  },
];

export function getLocationBySlug(slug: string | undefined): LocationContent | undefined {
  if (!slug) return undefined;
  return LOCATIONS.find((l) => l.slug === slug);
}
